import { useState } from "react";

function  OptionsTradingTechniqueModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "1. Understanding Market Sentiment and Options",
      content: [
        "Analyzing Option Chain Data: How to interpret call/put ratios, open interest, and volume.",
        "Using the Put-Call Ratio as a contrarian indicator.",
        "Volatility Indicators: Utilizing VIX, historical vs. implied volatility.",
        "Recognizing market sentiment through Max Pain Theory and its impact on options expiration.",
      ],
    },
    {
      title: "2. Directional Trading Strategies",
      content: [
        "Long Call and Long Put: Simple directional bets with leverage.",
        "Identifying entry signals using technical analysis (moving averages, RSI, MACD).",
        "Short Call and Short Put: Generating income with naked options (high risk).",
        "Understanding margin requirements and potential for unlimited losses.",
        "Synthetic Positions: Creating synthetic long or short positions using options.",
        "Example: Combining long calls with short puts to replicate stock ownership.",
      ],
    },
    {
      title: "3. Spread Trading Techniques",
      content: [
        "Bull Call Spread: Using call spreads for a bullish outlook with limited risk.",
        "Bear Put Spread: Leveraging put spreads for a bearish market view.",
        "Credit Spreads (Bull Put and Bear Call): Earning premium with limited risk.",
        "Example: Selling out-of-the-money options to collect premium.",
        "Choosing the right spread based on volatility and market conditions.",
      ],
    },
    {
      title: "4. Volatility-Based Strategies",
      content: [
        "Straddle: Profiting from significant price moves in either direction.",
        "Best applied during earnings announcements or major economic events.",
        "Strangle: A lower-cost alternative to the straddle.",
        "Example: Buying an out-of-the-money call and put.",
        "Iron Condor: Generating income in a low-volatility environment.",
        "Adjustments to iron condors when the market breaks out of range.",
        "Butterfly Spread: Capturing profits in a stable market with minimal movement.",
      ],
    },
    {
      title: "5. Time Decay (Theta) Strategies",
      content: [
        "Selling Covered Calls: Generating additional income on existing stock holdings.",
        "Cash-Secured Puts: Earning premium while waiting to buy stocks at a discount.",
        "Calendar Spread: Capturing time decay differences between two expiration dates.",
        "Diagonal Spread: Combining directional bias with time decay advantages.",
      ],
    },
    {
      title: "6. Advanced Option Techniques",
      content: [
        "Ratio Spreads: Leveraging directional bias with potential for unlimited profit.",
        "Example: Buying one option and selling two at a higher strike.",
        "Backspread: High-reward strategies for significant price moves.",
        "Example: Selling a lower strike option and buying multiple higher strike options.",
        "Iron Butterfly: More aggressive income strategy compared to iron condor.",
        "Box Spread: Risk-free arbitrage strategy (requires access to low-cost execution).",
      ],
    },
    {
      title: "7. Earnings and Event-Based Options Trading",
      content: [
        "Pre-Earnings Strategies: Trading implied volatility increase.",
        "Post-Earnings IV Crush: Strategies to profit from the rapid drop in IV after earnings.",
        "Using options to trade around major economic events (Fed meetings, GDP releases).",
        "News-Based Trading: Leveraging options during mergers, acquisitions, or product launches.",
      ],
    },
    {
      title: "8. Hedging and Protective Strategies",
      content: [
        "Protective Put: Limiting downside risk on your stock portfolio.",
        "Collar Strategy: Locking in profits while reducing risk (Covered Call + Protective Put).",
        "Using options to hedge against sector and market downturns.",
        "Rolling Options: Extending duration and adjusting strikes to maintain protection.",
      ],
    },
    {
      title: "9. Options Scanners and Analysis Tools",
      content: [
        "How to use options scanners to identify high-probability trades.",
        "Tools for tracking unusual options activity and large block trades.",
        "Using the Options Greeks (Delta, Gamma, Theta, Vega, Rho) for trade analysis.",
        "Leveraging platforms like Sensibull, Thinkorswim, and OptionNet Explorer for analysis.",
      ],
    },
    {
      title: "10. Risk Management and Position Sizing",
      content: [
        "Understanding the Risk/Reward Ratio for each trade.",
        "Using the Kelly Criterion for optimal position sizing.",
        "Managing risk with stop-loss orders and alerts.",
        "Portfolio Diversification: Balancing directional and non-directional trades.",
      ],
    },
    {
      title: "11. Live Trading Examples and Case Studies",
      content: [
        "Real-world examples of executing multi-leg options strategies.",
        "Case studies on adjusting trades under various market conditions.",
        "Walkthrough of a complete options trade: from analysis to execution and adjustments.",
        "Developing a personalized trading journal to track performance and refine strategies.",
      ],
    },
  ];

  return (
    <div className="container-fluid">
      <div className="container py-5">
        <h1 className="text-center mb-5">Intermediate Options Trading</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div key={index} className="col-12 col-md-5 mb-3">
              {/* Module Header */}
              <div
                className="p-3 d-flex justify-content-between align-items-center"
                style={{
                  background: "#e9ecef",
                  border: "1px solid #ced4da",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: "18px",
                    transform: openModule === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Module Content */}
              {openModule === index && (
                <div
                  className="p-3 mt-2"
                  style={{
                    background: "#ffffff",
                    border: "1px solid #ced4da",
                    borderRadius: "5px",
                  }}
                >
                  {module.content.map((item, i) => (
                    <p key={i} style={{ fontSize: "14px", margin: "5px 0" }}>
                      ➤ {item}
                    </p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OptionsTradingTechniqueModule;
